<template>
  <div>
    <b-nav-item v-if="!showIcon" @click="showForm = !showForm" active-class="active" style="display: inline;"> Notifications <b-badge v-if="newNotifications > 0" pill variant="danger">{{ newNotifications }}</b-badge></b-nav-item>

    <b-modal id="modal-1" title='Notifications' v-model="showForm" :lazy="true"
      hide-footer
      size="xl">

      <b-container fluid>
        <b-row>
          <b-col class="p-4">
            <b-input-group>
              <b-form-input
                v-model="searchText"
                placeholder="Search"
                type="text"
                debounce="500">
              </b-form-input>
              <b-input-group-append>
                <b-button v-on:click="searchText = ''"><b-icon-x></b-icon-x></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>
        <b-col class="text-right">
          <b-pagination v-model="pagination.page" :total-rows="pagination.total" :per-page="pagination.pageSize" align="right" v-if="!loading" @change="loadData"></b-pagination>
        </b-col>
        <b-row>
          <b-col class="p-4">
            <b-table small :items="messages" :fields="fields" :busy="loading" class="text-left">
              <template v-slot:table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>

              <template v-slot:cell(sentById)="data">
                {{data.value}}
              </template>

              <template v-slot:cell(text)="data">
                {{data.value}}
              </template>

              <template v-slot:cell(dateSent)="data">
                {{data.value | formatDate}}
              </template>

              <template v-slot:cell(isRead)="data">
                <b-form-checkbox
                  v-model="data.value"
                  @change="markRead(data.item)"
                >
                </b-form-checkbox>
              </template>

              <template v-slot:cell(dateRead)="data">
                {{data.value | formatDate}}
              </template>

              <template v-slot:cell(actions)="data">
                <b-button variant="link" v-on:click="deleteMessage(data.item)" style="display: inline;"><b-icon icon="trash" variant="danger"></b-icon></b-button>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-container>

      <b-button class="mt-3 float-right" style="width: 100px" block @click="$bvModal.hide('modal-1')">Close</b-button>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import VaWorksApi from '@/api/VaWorksApi'
import moment from 'moment'

Vue.filter('formatDate', function (value) {
  return moment(value).format('ll')
})

export default {
  props: [ 'showIcon' ],
  name: 'MessagesViewPage',
  data () {
    return {
      fields: [ { key: 'sentBy.name', label: 'Sent By' }, { key: 'text', label: 'Message' }, 'dateSent', { key: 'isRead', label: 'Read' }, 'dateRead', { key: 'actions', label: '' } ],
      messages: [],
      loading: true,
      searchText: '',
      showForm: false,
      pagination: {
        pageSize: 10,
        page: 1,
        total: 0
      },
      newMessage: {
        id: 0,
        text: '',
        sentToId: 0,
        sentById: 0,
        orgId: 0
      },
      newNotifications: null
    }
  },
  created () {
    let vm = this
    this.loadData(1)
    VaWorksApi().get(`Message/for/${vm.user.id}?page=${1}&pageSize=${100}&includeRead=false`)
      .then((r) => {
        vm.newNotifications = r.data.total
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        localStorage.setItem('unreadNotifications', vm.newNotifications)
      })
  },
  computed: {
    user () {
      return this.$store.state.auth.currentUser
    }
  },
  methods: {
    loadData (page) {
      var vm = this
      vm.loading = true
      VaWorksApi().get(`Message/for/${vm.user.id}?page=${page}&pageSize=${vm.pagination.pageSize}&includeRead=true&search=${vm.searchText}`)
        .then((r) => {
          vm.messages = r.data.items
          vm.pagination.total = r.data.total
          vm.pagination.page = page
          vm.pagination.pageSize = r.data.pageSize
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          vm.loading = false
        })
    },
    markRead (result) {
      var vm = this
      vm.loading = true
      result.isRead = !result.isRead
      VaWorksApi().put('Message/' + result.id, result)
        .then((r) => {
          vm.loadData(vm.pagination.page)
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          const unread = localStorage.getItem('unreadNotifications')
          let tempNewNotifications = result.isRead ? unread - 1 : parseInt(unread) + 1
          localStorage.setItem('unreadNotifications', tempNewNotifications)
          vm.newNotifications = localStorage.getItem('unreadNotifications')
        })
    },
    deleteMessage (message) {
      let vm = this
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete this message?', {
        title: 'Delete User Message',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true

      })
        .then(value => {
          VaWorksApi().delete(`Message/${message.id}`)
            .then((r) => {
              vm.messages.splice(vm.messages.findIndex((n) => n.id === message.id), 1)
              localStorage.setItem('unreadNotifications', localStorage.getItem('unreadNotifications') - 1)
              vm.newNotifications = localStorage.getItem('unreadNotifications')
            })
            .catch((e) => {
              console.log(e)
            })
        })
        .catch((e) => {
          console.log(e)
        })
    }
  },
  watch: {
    searchText (value) {
      this.loadData(1)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/admin/messages/components/MessageView.vue